import { SelectableIconCard } from '@juvare/common-web-ui/Cards/SelectableIconCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { formatDate } from '@juvare/common-web-ui/utils';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import { parseISO } from 'date-fns';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { useAlertServiceClient } from '../../hooks';
import { AlertIcon } from '../AlertIcon/AlertIcon';
import { ChannelIcon } from '../ChannelIcon';
export const AlertCard = ({ alert, checked, selected, onCardClick, onIconClick, onReloadList }) => {
    var _a, _b, _c, _d;
    const { t } = useAlertUiTranslation();
    const statusLikeSent = alert.status && ['sent', 'sending', 'failed', 'archived'].includes(alert.status);
    const dateTime = statusLikeSent ? ((_b = (_a = alert.sendDateTime) !== null && _a !== void 0 ? _a : alert.terminatedAt) !== null && _b !== void 0 ? _b : alert.updated) : alert.updated;
    const user = statusLikeSent ? alert.sentBy : alert.updatedBy;
    const title = statusLikeSent || alert.status === 'draft' ? alert.subject : alert.title;
    const content = (React.createElement(Box, { sx: { display: 'grid', gridTemplateRows: 'auto auto auto', gridTemplateColumns: '100%', px: 2, py: 1.5 } },
        React.createElement(Typography, { variant: 'caption', sx: { color: themeColors.text.subtle, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
            dateTime ? formatDate(parseISO(dateTime)) : '',
            " \u00A0\u25CF\u00A0 ",
            user),
        React.createElement(Box, { sx: { display: 'flex', gap: 1, alignItems: 'center' } },
            React.createElement(Typography, { variant: 'subtitle1', sx: {
                    width: 0,
                    flexGrow: 1,
                    color: themeColors.text.main,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } },
                alert.status === 'draft' && (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { component: 'span', color: themeColors.accent.red.bold }, t('common.draft')),
                    ' - ')),
                title),
            alert.status === 'failed' && !alert.terminatedAt && (React.createElement(Tooltip, { title: t('common.deliveryFailed') },
                React.createElement(ErrorOutlineIcon, { color: 'error', fontSize: 'small' }))),
            alert.terminatedAt && (React.createElement(Tooltip, { title: t('common.deliveryCanceled') },
                React.createElement(WarningAmberOutlinedIcon, { color: 'warning', fontSize: 'small' })))),
        React.createElement(Typography, { sx: { color: themeColors.text.subtle, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, (_c = alert.channels) === null || _c === void 0 ? void 0 : _c.map((channel) => (React.createElement(ChannelIcon, { key: channel, channel: channel, tooltip: true, sx: { fontSize: 16, verticalAlign: 'middle', ml: 1, '&:first-of-type': { ml: 0 } } }))))));
    const { id } = useUserState();
    const alertServiceClient = useAlertServiceClient();
    return (React.createElement(SelectableIconCard, { checked: checked, selected: selected, icon: React.createElement(AlertIcon, { icon: alert.icon }), color: ((_d = alert.color) !== null && _d !== void 0 ? _d : 'grey'), onCardClick: onCardClick, cardAriaLabel: t('common.select', { title }), onIconClick: onIconClick, iconAriaLabel: selected ? t('common.deselect', { title }) : t('common.select', { title }) }, alert.status === 'template' ? (React.createElement(Box, { sx: { display: 'grid', gridTemplateColumns: '1fr auto auto', gap: 1 } },
        content,
        React.createElement(Divider, { orientation: 'vertical', sx: { alignSelf: 'center', height: 24 } }),
        React.createElement(Tooltip, { title: alert.pinned ? t('common.unpin') : t('common.pin') },
            React.createElement(IconButton, { sx: { alignSelf: 'center', mr: 1 }, color: 'primary', onClick: (event) => {
                    event.stopPropagation();
                    const alertPins = alert.pinned ? [] : [{ type: 'user', externalId: id }];
                    alertServiceClient
                        .pinAlert(alert.id, alertPins)
                        .then(() => {
                        showAlertSnackbar({
                            type: 'success',
                            message: alert.pinned ? t('pages.tables.templateUnpinned') : t('pages.tables.templatePinned'),
                        });
                        onReloadList === null || onReloadList === void 0 ? void 0 : onReloadList();
                    })
                        .catch(handleErrorSnackbar);
                } }, alert.pinned ? React.createElement(PushPinIcon, null) : React.createElement(PushPinOutlinedIcon, null))))) : (content)));
};
